/******************************************************************************
 * This file was generated by langium-cli 3.3.0.
 * DO NOT EDIT MANUALLY!
 ******************************************************************************/

import type { LangiumSharedCoreServices, LangiumCoreServices, LangiumGeneratedCoreServices, LangiumGeneratedSharedCoreServices, LanguageMetaData, Module } from 'langium';
import { MermaidAstReflection } from './ast.js';
import { InfoGrammar, PacketGrammar, PieGrammar, ArchitectureGrammar, GitGraphGrammar, RadarGrammar, TreemapGrammar } from './grammar.js';

export const InfoLanguageMetaData = {
    languageId: 'info',
    fileExtensions: ['.mmd', '.mermaid'],
    caseInsensitive: false,
    mode: 'production'
} as const satisfies LanguageMetaData;

export const PacketLanguageMetaData = {
    languageId: 'packet',
    fileExtensions: ['.mmd', '.mermaid'],
    caseInsensitive: false,
    mode: 'production'
} as const satisfies LanguageMetaData;

export const PieLanguageMetaData = {
    languageId: 'pie',
    fileExtensions: ['.mmd', '.mermaid'],
    caseInsensitive: false,
    mode: 'production'
} as const satisfies LanguageMetaData;

export const ArchitectureLanguageMetaData = {
    languageId: 'architecture',
    fileExtensions: ['.mmd', '.mermaid'],
    caseInsensitive: false,
    mode: 'production'
} as const satisfies LanguageMetaData;

export const GitGraphLanguageMetaData = {
    languageId: 'gitGraph',
    fileExtensions: ['.mmd', '.mermaid'],
    caseInsensitive: false,
    mode: 'production'
} as const satisfies LanguageMetaData;

export const RadarLanguageMetaData = {
    languageId: 'radar',
    fileExtensions: ['.mmd', '.mermaid'],
    caseInsensitive: false,
    mode: 'production'
} as const satisfies LanguageMetaData;

export const TreemapLanguageMetaData = {
    languageId: 'treemap',
    fileExtensions: ['.mmd', '.mermaid'],
    caseInsensitive: false,
    mode: 'production'
} as const satisfies LanguageMetaData;

export const MermaidGeneratedSharedModule: Module<LangiumSharedCoreServices, LangiumGeneratedSharedCoreServices> = {
    AstReflection: () => new MermaidAstReflection()
};

export const InfoGeneratedModule: Module<LangiumCoreServices, LangiumGeneratedCoreServices> = {
    Grammar: () => InfoGrammar(),
    LanguageMetaData: () => InfoLanguageMetaData,
    parser: {}
};

export const PacketGeneratedModule: Module<LangiumCoreServices, LangiumGeneratedCoreServices> = {
    Grammar: () => PacketGrammar(),
    LanguageMetaData: () => PacketLanguageMetaData,
    parser: {}
};

export const PieGeneratedModule: Module<LangiumCoreServices, LangiumGeneratedCoreServices> = {
    Grammar: () => PieGrammar(),
    LanguageMetaData: () => PieLanguageMetaData,
    parser: {}
};

export const ArchitectureGeneratedModule: Module<LangiumCoreServices, LangiumGeneratedCoreServices> = {
    Grammar: () => ArchitectureGrammar(),
    LanguageMetaData: () => ArchitectureLanguageMetaData,
    parser: {}
};

export const GitGraphGeneratedModule: Module<LangiumCoreServices, LangiumGeneratedCoreServices> = {
    Grammar: () => GitGraphGrammar(),
    LanguageMetaData: () => GitGraphLanguageMetaData,
    parser: {}
};

export const RadarGeneratedModule: Module<LangiumCoreServices, LangiumGeneratedCoreServices> = {
    Grammar: () => RadarGrammar(),
    LanguageMetaData: () => RadarLanguageMetaData,
    parser: {}
};

export const TreemapGeneratedModule: Module<LangiumCoreServices, LangiumGeneratedCoreServices> = {
    Grammar: () => TreemapGrammar(),
    LanguageMetaData: () => TreemapLanguageMetaData,
    parser: {}
};
